var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"area-select"},[_c('el-cascader',{style:({width: _vm.width}),attrs:{"options":_vm.options},model:{value:(_vm.areaValue),callback:function ($$v) {_vm.areaValue=$$v},expression:"areaValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }